import type { SyntheticEvent } from "react";

/**
 * Voice samples (market, inventory, mascot profile) are served by ai-service, spoken by
 * whichever TTS vendor the mascot chat is routed to — so the sample a learner hears before
 * buying a voice is the voice they get in the chat, even after the backend switches vendor.
 * The clip bundled under `public/audios/` is only the fallback when that request fails.
 */
export const buildVoiceSampleUrl = (
  aiBaseUrl: string,
  voiceName: string,
  language: string = "TURKISH",
): string =>
  `${aiBaseUrl}/ai/tts/voice-sample?voice=${encodeURIComponent(voiceName)}&screen=chat&language=${encodeURIComponent(language)}`;

export const getBundledVoiceSampleUrl = (voiceName: string): string =>
  `/audios/${voiceName}.wav`;

/** `<audio onError>`: fall back to the bundled clip once (never loop if that fails too). */
export const fallBackToBundledVoiceSample =
  (voiceName: string) =>
  (event: SyntheticEvent<HTMLAudioElement>): void => {
    const audio = event.currentTarget;
    const bundled = getBundledVoiceSampleUrl(voiceName);
    if (!audio.src.endsWith(bundled)) {
      audio.src = bundled;
    }
  };
